import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/Theme';

import { RtlStyles } from './styles/RtlStyles';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePageEn from './pages/HomePageEn';
import HomePageHe from './pages/HomePageHe';
import HomePage from './pages/HomePage';
import RidesPage from './pages/RidesPage';
import DriverPage from './pages/DriverPage';
import './App.css';
import Navbar from './components/Navbar';
import FloatingLangSwitch from './components/FloatingLangSwitch';

const App: React.FC = () => {
  const location = useLocation();
  // Arabic-only static app, no language switcher or i18n logic


  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <RtlStyles />
      <div className="App">
        <Navbar minimal={location.pathname === '/'} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/en" element={<HomePageEn />} />
          <Route path="/he" element={<HomePageHe />} />
          <Route path="/rides" element={<RidesPage />} />
          <Route path="/driver" element={<DriverPage />} />
        </Routes>
      </div>
      {/* Floating Language Switch Button above WhatsApp */}
      <FloatingLangSwitch />
      {/* Fixed WhatsApp Button */}
      <a
        href="https://wa.me/972587766382"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 9999,
          background: 'rgba(255,255,255,0.15)',
          borderRadius: '50%',
          width: 64,
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
          cursor: 'pointer',
          padding: 0,
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          border: '1.5px solid #e0e0e0',
        }}
        aria-label="تواصل عبر واتساب"
      >
        <img src="/images/whatsapp.svg" alt="WhatsApp" width="38" height="38" style={{ display: 'block', borderRadius: '50%' }} />
      </a>
    </ThemeProvider>
  );
};

export default App; 